import * as React from "react";
const SvgHMobiledata = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z",
  fill: "currentColor"
}));
export default SvgHMobiledata;